module.exports = __webpack_public_path__ + "img/图片27.b30126a1.png";